import React from 'react'
import Error from 'next/error'
import { api } from 'utils'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import MetaSeo from 'components/atomic/MetaSeo'
import { PAGINEDETAIL, MODULOFORMAZIONE, SLUG } from 'utils/endpoint'
import { Correlati, ListingModuliWebinar } from 'react-components/organisms'
import { FormazioneModuloCardHeader } from 'react-components/molecules'
import { WebinarContextProvider } from 'utils/webinarContext'
import PlaceholderReact from 'components/atomic/PlaceholderReact'
import { useTrans } from 'hooks'

const ModuloDetail = ({ page, statusCode, modulo, lezioni, articoli, strumenti }) => {
  if (!page) return <Error statusCode={statusCode} />

  const t = useTrans()

  return (
    <WebinarContextProvider modulo={modulo}>
      <MetaSeo seo={page.seo} />
      <main className="formazione-corsi-page">
        <div className="w-container-fluid u-before-section u-background-image">
          <div className="w-container">
            <Breadcrumbs breadcrumbs={page.breadcrumbs} />
          </div>

          <div className="formazione-corsi-page__header">
            <div className="w-container">
              <FormazioneModuloCardHeader modulo={modulo} />
              <div className="formazione-corsi-page__header__pagebuilder">
                <PlaceholderReact
                  pkey={`formazione-corsi-${modulo.id}`}
                  contentTypeId={modulo.model}
                  objectId={modulo.id}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="formazione-corsi-page__content u-bg-white">
          <ListingModuliWebinar
            webinars={modulo.webinars_in_corso}
            withBorder={true}
            ultimoContenuto={modulo.ultimo_contenuto ? modulo.ultimo_contenuto : null}
          />
          <ListingModuliWebinar
            webinars={modulo.webinars_conclusi}
            sottotitolo={t('Webinar Conclusi')}
          />
        </div>
        <Correlati articoli={articoli} strumenti={strumenti} lezioni={lezioni} />
      </main>
    </WebinarContextProvider>
  )
}

// export async function getStaticPaths() {
//   const response = await api.get(MODULOFORMAZIONE)
//   const moduli = response.data

//   const paths = moduli
//     .map(d => ({
//       params: { slug: d.slug },
//     }))
//     .slice(0, 5)

//   return {
//     paths,
//     fallback: 'blocking',
//   }
// }

export const getServerSideProps = async ({ query, req, res }) => {
  const headers = req?.headers?.cookie
    ? { cookie: req.headers.cookie, anteprima: req.headers.anteprima || false }
    : undefined

  try {
    const moduloResponse = await api.get(`${MODULOFORMAZIONE}${SLUG}${query.slug}/`, { headers })
    const modulo = await moduloResponse.data

    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'formazione-modulo-detail',
        content_type_id: modulo.model,
        object_id: modulo.id,
      },
    })
    const page = await pageResponse.data

    const urlCorrelati = `${MODULOFORMAZIONE}${modulo.id}/risorse_correlate/`

    const lezioniResponse = await api.get(urlCorrelati, {
      params: { limit: 3, excluded: 'raccolta/strumento/articolo', related: 'corso' },
    })
    const lezioni = lezioniResponse.data

    const articoliResponse = await api.get(urlCorrelati, {
      params: { limit: 3, excluded: 'raccolta/strumento/lezione', related: 'corso' },
    })
    const articoli = articoliResponse.data

    const strumentiResponse = await api.get(urlCorrelati, {
      params: { limit: 3, excluded: 'raccolta/lezione/articolo', related: 'corso' },
    })
    const strumenti = strumentiResponse.data

    const toolbarProps = { toolbarPage: page, toolbarItem: modulo }

    return {
      props: { page, ...toolbarProps, modulo, lezioni, articoli, strumenti },
      // revalidate: 1
    }
  } catch (error) {
    console.log(error)
    if (res) {
      res.statusCode = 404
    }
    return { props: { statusCode: 404 } }
  }
}

export default ModuloDetail
